import React, { useContext } from 'react'

import useDataLayer from 'src/hooks/useDataLayer/dataLayerFooter'
import { ThemeContext } from 'styled-components'

import OrangeIcon from '../Icon/OrangeDsIcon'
import { UL } from './style'
import { DirectionMediaProps, FloatingSocialMediaProps } from './types'

const isBrowser = typeof window !== 'undefined'
const whatsapp = 'whatsapp'

const FloatingSocialMedia = ({
  items,
  sharer,
  pageContext,
  direction,
  justifyContent,
  pageUrl,
}: DirectionMediaProps) => {
  const [sendDatalayerEvent] = useDataLayer()
  const { colors } = useContext(ThemeContext)

  function getUrlSharer(item: FloatingSocialMediaProps) {
    if (!isBrowser && !sharer) {
      return `${item.url}`
    }
    if (!sharer && isBrowser) {
      return `${item.url}`
    }
    if (pageUrl) {
      if (item.icon === whatsapp && pageContext?.fileContents) {
        return `${item.url}${pageContext?.fileContents.title}${pageUrl}`
      }
      return `${item.url}${pageUrl}`
    }
    return item.url
  }

  return (
    <>
      <UL
        className={direction === 'row' ? `d-flex flex-row ${justifyContent}` : 'd-flex flex-column'}
        absolute={direction === 'row' ? 'inherit' : 'absolute'}
      >
        {items.map((item: FloatingSocialMediaProps) => (
          <li key={item.title}>
            <a
              href={getUrlSharer(item)}
              target="_blank"
              title={item.title}
              rel="noreferrer"
              onClick={() => {
                sendDatalayerEvent({
                  section: '',
                  element_action: 'click button',
                  element_name: item.title,
                  redirect_url: item.url,
                })
              }}
            >
              <OrangeIcon color={colors.primary} icon={item.icon || ''} size="LD" />
            </a>
          </li>
        ))}
      </UL>
    </>
  )
}

export default FloatingSocialMedia
